import styled from "styled-components";

export const ChartsWrapper = styled.div`
  display: flex;
  width: 100%;
`;

export const ChartMetricWrapper = styled.div`
  display: flex;
  gap: 80px;
  flex-direction: column;
  padding: 14px;
  border-right: 1px dotted ${({ theme }) => theme.colors.dataViz.chartMetricBorder};

  :first-child {
    padding-left: 0;
  }

  :last-child {
    border-right: none;
  }
`;
